import { Button } from "primereact/button";
import { useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import {
	type rewardForm_RewardFragment$key,
	type RewardKind,
} from "@relay/rewardForm_RewardFragment.graphql";
import { type rewardForm_TreeNodeFragment$key } from "@relay/rewardForm_TreeNodeFragment.graphql";
import { REWARD_CONFIGURATION_FRAGMENT, TREE_NODE_FRAGMENT } from "./reward-form.graphql";
import { type RewardFormProps } from "./reward-form.types";
import { selectArrayOfEditedForms } from "../../../../store/slices/CoreSlice";
import { useTypedSelector } from "../../../../store/store.redux";
import { ExternalLicenseRewardForm } from "../external-license-reward-form";
import { IHKCertificateRewardBundleForm } from "../ihk-certificate-reward-bundle-form";

export const RewardForm = ({
	treeNodeFragmentRef,
	rewardConfigurationFragmentRef,
	onBack: handleOnClick,
}: RewardFormProps) => {
	const { t } = useTranslation("common");
	const node = useFragment<rewardForm_TreeNodeFragment$key>(
		TREE_NODE_FRAGMENT,
		treeNodeFragmentRef,
	);
	const reward = useFragment<rewardForm_RewardFragment$key>(
		REWARD_CONFIGURATION_FRAGMENT,
		rewardConfigurationFragmentRef,
	);
	const arrayOfEditedForm = useTypedSelector(selectArrayOfEditedForms);

	const Form = (() => {
		switch (reward.kind) {
			case "ExternalLicense":
				return (
					<ExternalLicenseRewardForm
						contentNodeId={node.id}
						externalLicenseRewardFragmentRef={reward}
						onBack={handleOnClick}
					/>
				);

			case "IHKCertificateBundle":
				return (
					<IHKCertificateRewardBundleForm
						contentNodeId={node.id}
						ihkCertificateRewardBundleFragmentRef={reward}
					/>
				);
			default:
				return null;
		}
	})();

	const REWARD_TRANSLATION_KEYS: Record<RewardKind, string> = {
		ExternalLicense: "educationalOffer.rewards.kinds.ExternalLicense",
		GamificationPoints: "educationalOffer.rewards.kinds.GamificationPoints",
		IHKCertificate: "educationalOffer.rewards.kinds.IHKCertificate",
		IHKCertificateBundle: "educationalOffer.rewards.kinds.IHKCertificateBundle",
		CrmTreeHeadUpdater: "educationalOffer.rewards.kinds.CrmTreeHeadUpdater",
		LearnStreak: "educationalOffer.rewards.kinds.LearnStreak",
	};
	return (
		<div>
			<div className="flex align-items-center">
				<h2>{t(REWARD_TRANSLATION_KEYS[reward.kind])}</h2>
				<Button
					disabled={arrayOfEditedForm.length > 0}
					className="ml-auto"
					icon="pi pi-times"
					onClick={handleOnClick}
				/>
			</div>
			{Form}
		</div>
	);
};
